import { createFileRoute, Navigate } from '@tanstack/react-router';
import { isStandalone } from '~portal/lib';
import { HomePage } from './-home/HomePage';

export const Route = createFileRoute('/_protected/')({
  component: IndexPage,
});

function IndexPage() {
  // Standalone is the agent alone — it has no home page, so `/` opens a new chat.
  if (isStandalone) {
    return <Navigate to="/chat/$conversationId" params={{ conversationId: 'new' }} />;
  }

  return <HomePage />;
}
